import * as React from 'react';
import { NavigationUser } from './NavigationUser/NavigationUser';
import { NavigationMember } from './NavigationMember/NavigationMember';
import { NavigationAdmin } from './NavigationAdmin/NavigationAdmin';
import { NavigationSemiPro } from './NavigationSemiPro/NavigationSemiPro';
import { UserRole } from '../../../types/UserRole';
import LoginServices from '../../../services/LoginServices';

export class NavigationChorinitia extends React.Component {

    render() {
        if (LoginServices.getInstance().getType() === UserRole.USER.toString()) {
            return (<NavigationUser />);
        } else if (LoginServices.getInstance().getType() === UserRole.MEMBER.toString()) {
            return (<NavigationMember />);
        } else if (LoginServices.getInstance().getType() === UserRole.ADMIN.toString()) {
            return (<NavigationAdmin />);
        } else if (LoginServices.getInstance().getType() === UserRole.SEMI_PRO.toString()) {
            return (<NavigationSemiPro />);
        } else {
            return (<div/>);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Navigation/NavigationChorinitia.tsx